import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../utils';

export const setAiContentWidgetShowAi = createAction(
  `${reduxKey}.SET_AICONTENT_WIDGET_SHOW_AI`,
  (showAi: boolean) => ({ showAi })
);

export const {
  submit: saveAiContent,
  success: saveAiContentSuccess,
  failure: saveAiContentFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_AICONTENT');
